<script>
  import { navigate } from "svelte-routing"
  export let personas

  const cargarPersona = (documento) => {
    navigate(`/persona/${documento}`, { replace: true })
  }
</script>

<div class="table-responsive small">
  <table class="table table-striped table-sm table-hover table-pointer">
    <thead>
      <tr>
        <th class="fg-secondary fw-normal">Documento</th>
        <th class="fg-secondary fw-normal">Apellidos y Nombres</th>
        <th class="fg-secondary fw-normal" />
      </tr>
    </thead>
    <tbody>
      {#each personas as persona}
        {#if persona.res == persona.documento && personas.length == 1}
          <tr>
            <td colspan="3">
              <p class="text-center fg-secondary m-0">
                · · · Información no disponible · · ·
              </p>
            </td>
          </tr>
        {:else if persona.res != persona.documento}
          <tr on:click={() => cargarPersona(persona.documento)}>
            <td>{persona.documento}</td>
            <td>{persona.paterno} {persona.materno} {persona.nombres}</td>
            <td class="text-end fg-primary">
              <i class="bi bi-chevron-right"></i>
            </td>
          </tr>
        {/if}
      {/each}
    </tbody>
  </table>
</div>
